import React, { useCallback} from 'react';
import Button from "../../Button/Button";

const AssistConfigBaseTableColumns = ({ onModalOpen }) => {
	const formatTo70CharsWithEllipsis = (text) => {
		return text.length > 70 ? text.slice(0, 67) + '...' : text;
	}
	const getTooltipProps = useCallback((value) => ({
		"data-tooltip-id": "table-tooltip",
		"data-tooltip-html": value.join('<br />'),
		"data-tooltip-place": "top",
	}), []);
	
	const columns = [
		{
			Header: 'Notification Name',
			accessor: 'name',
		},
		{
			Header: 'Page URL',
			accessor: 'triggerUrl',
			Cell: ({ value }) => (<span { ...getTooltipProps(value)}> {formatTo70CharsWithEllipsis(value[0])} </span>),
		},
		{
			Header: 'Active',
			accessor: 'active',
			Cell: ({ value }) => {
				const cellStyle = { padding: "5px 15px", borderRadius: "10px" };

				if (value) {
					return <span style={{ ...cellStyle, backgroundColor: "#dcfce7"}}>Yes</span>
				}

				return <span style={{ ...cellStyle, backgroundColor: "#e2e8f0"}}>No</span>
			}
		},
		{
			Header: 'Actions',
			accessor: 'id',
			Cell: ({value}) => (
				<div className="actions" style={{display: 'inline-flex'}}>
					<Button
						generalType="default"
						className="ml-2"
						type="button"
						onClick={() => onModalOpen(value, 'edit')}
						title="Edit"
					>
						<i className="mdi mdi-pencil" />
					</Button>
					<Button
						generalType="default"
						className="ml-2"
						type="button"
						onClick={() => onModalOpen(value, 'delete')}
						title="Delete"
					>
						<i className="mdi mdi-delete" />
					</Button>
					<Button
						generalType="default"
						className="ml-2"
						type="button"
						onClick={() => onModalOpen(value, 'active')}
						title="Active"
					>
						<i className="mdi mdi-checkbox-marked-circle" />
					</Button>
				</div>
			),
		},
	];
	
	return columns;
};

export default AssistConfigBaseTableColumns;
